import React, { useEffect, useRef } from "react";

interface Prop {
    load: (() => Promise<void>),
    children: React.ReactNode,
    loaded: boolean
}
export default function ({ children, loaded, load }: Prop) {
    const genericRef = useRef(null)
    useEffect(() => {
        const OPTIONS = {
            root: null, // use the viewport as the container
            rootMargin: '0px',
            threshold: 0.5 // trigger when 100% of the target is visible
        }
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(async (entry) => {
                if (entry.isIntersecting) {
                    if (!loaded) {
                        await load!()
                    }
                    console.log("Component is loaded")
                }
            });
        }, OPTIONS)

        if (genericRef.current) {
            observer.observe(genericRef.current);
        }

        return () => {
            if (genericRef.current) {
                observer.unobserve(genericRef.current);
            }
        };
    }, [])
    return <div ref={genericRef}>
        {children}
    </div>
}